import { render, staticRenderFns } from "./ProductionProcedures.vue?vue&type=template&id=1cb956e9"
import script from "./ProductionProcedures.vue?vue&type=script&lang=js"
export * from "./ProductionProcedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports